import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgField = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 22",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M16,7.6l-3.8-2.1c-.6-.4-1.7-.4-2.3,0l-3.8,2.1,5,2.7,4.9-2.7Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M4.7,8.4l-3.6,2c-.6.4-.6.9,0,1.3l3.8,2.1,4.8-2.7-5-2.7Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.2,14.5l3.6,2c.6.4,1.7.4,2.3,0l3.7-2-4.8-2.6-4.8,2.7Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M20.9,10.4l-3.6-2-4.9,2.7,4.8,2.6,3.8-2.1c.6-.4.6-.9,0-1.3Z" })
	]
});
export default SvgField;
